import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=4786e6be&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=js&"
export * from "./table-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786e6be",
  null
  
)

export default component.exports